import axios from 'axios';

export default axios.create({
 baseURL: 'https://api-neobet.onrender.com'
  //BASE DA API ON-LINE baseURL: 'https://api-phd.onrender.com/'
  //BASE PARA RODAR LOCALMENTE baseURL: 'http://localhost:3333/'   
}); 